/**
 * Fingering
 */
export default class Fingering {
  pitch: number; //e.g. 60 for middle C.  probably the same as midi note number?
  color: string; //e.g. #60bcbe.  Not sure if this changes.
  finger?: number; //sometimes this is not included. e.g. "1" for finger 1 should be on this pitch/key
  constructor({ pitch, color, finger, }: Fingering) {
    Object.assign(this, { pitch, color, finger, });
  }
}